/* eslint-disable import/prefer-default-export */
import { orgArtistsUrl } from '../urls';
import refresh from '../refresh';

export async function getOrgArtist(orgId, artistId) {
  return refresh(async () => {
    const response = await fetch(`${orgArtistsUrl}?${new URLSearchParams({
      org: orgId,
      artist: artistId,
    })}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
